import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TypeQuantite } from '../../../facturation/shared/classes/type-quantite';
import { ArticleService } from '../../../facturation/shared/services/article.service';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';

@Component({
  selector: 'app-admin-list-article-type-unite',
  templateUrl: './admin-list-article-type-unite.component.html',
  styleUrls: ['./admin-list-article-type-unite.component.css']
})
export class AdminListArticleTypeUniteComponent implements OnInit {
    lstPays: any[];
    newTypeQuantite = new TypeQuantite({});
    selected = new FormControl(0);


    @Input() typesQuantites: TypeQuantite[] = [];
    @Output() changeTypeQuantite: EventEmitter<TypeQuantite> = new EventEmitter();

    constructor(
        private articleService: ArticleService,
        private alertService: AlertService
    ) { }

    ngOnInit() {}

    getTypesQuantites() {
        this.articleService.getTypeQuantiteList()
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.typesQuantites = [];
                    retour.data.forEach(element => {
                        this.typesQuantites.push(new TypeQuantite(element));
                    });
                }
            });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1 && this.typesQuantites.length <= 0) { 
            this.getTypesQuantites();
        }
    }

    insertTypeQuantite(type: TypeQuantite) {
        this.articleService.insertTypeQuantite(type)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.newTypeQuantite = new TypeQuantite({});
                    this.alertService.success(TRANSLATE('Unité ajoutée avec succès'));
                    this.changeTypeQuantite.emit();
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    updateTypeQuantite(type: TypeQuantite) {
        this.articleService.updateTypeQuantite(type.atq_id, type)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Unité modifiée avec succès'));
                    this.changeTypeQuantite.emit();
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    deleteTypeQuantite(type: TypeQuantite) {
        this.articleService.deleteTypeQuantite(type.atq_id)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Unité supprimée avec succès'));
                    this.changeTypeQuantite.emit();
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

}
